// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state/preferences';

const updateCurrentLanguageKey = (state, action) => action.key;

export default (state = getDefaultState().currentLanguageKey, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_PREFERENCES_CURRENT_LANGUAGE_KEY]: updateCurrentLanguageKey
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/user/shared/reducers/update-current-language.js